import { createBrowserRouter, RouteObject } from 'react-router-dom';
import App from '@/App';
import { Login, Register, PasswordResetRequest, PasswordResetConfirm, ConnectWhoop, WhoopOAuthCallback, WhoopSimple, WhoopSimpleCallback, ConnectTerra, ConnectWearable, ConnectTerraCoach } from '@/auth';
import { PersonalDashboard } from '@/components';
import UnifiedDashboard from '@/components/UnifiedDashboard';
import { CoachDashboard } from '@/components/coach-dashboard';
import { CatapultDashboard } from '@/components/catapult-dashboard';
import { AdminDashboard } from '@/components/admin-dashboard';
import { TeamInfo } from '@/components/team-information';
import { TeamHealthDashboard } from '@/components/team-health';
import { AthleteDetail } from '@/components/athlete-detail';
import SettingsPage from '@/components/settings/SettingsPage';
import { PageviewTracker } from '@/components/shared/PageviewTracker';
import { AthleteCheckIn, DailyCheckInForm } from '@/components/sessions';
import Landing from '@landing/Landing';
import ServicesPage from '@landing/30-services/30-ServicesPage';
import PricingPage from '@landing/40-pricing/40-PricingPage';
import AboutPage from '@landing/20-about/20-AboutPage';
import ContactPage from '@landing/50-contact/50-ContactPage';
import BlogListingPage from '@landing/60-blog/60-BlogListingPage';
import BlogPostPage from '@landing/60-blog/61-BlogPostPage';

export const router = createBrowserRouter([
    {
        path: '/',
        element: (
            <>
                <PageviewTracker />
                <App />
            </>
        ),
        children: [
            {
                index: true,
                element: <Landing />,
            },
            {
                path: 'services',
                element: <ServicesPage />,
            },
            {
                path: 'pricing',
                element: <PricingPage />,
            },
            {
                path: 'about',
                element: <AboutPage />,
            },
            {
                path: 'contact',
                element: <ContactPage />,
            },
            {
                path: 'blog',
                element: <BlogListingPage />,
            },
            {
                path: 'blog/:slug',
                element: <BlogPostPage />,
            },
            {
                path: 'login',
                element: <Login />,
            },
            {
                path: 'register',
                element: <Register />,
            },
            {
                path: 'password-reset',
                element: <PasswordResetRequest />,
            },
            {
                path: 'reset-password/:uid/:token',
                element: <PasswordResetConfirm />,
            },
            {
                path: 'dashboard',
                element: <UnifiedDashboard />,
            },
            {
                path: 'coach-dashboard',
                element: <CoachDashboard />,
            },
            {
                path: 'catapult-dashboard',
                element: <CatapultDashboard />,
            },
            {
                path: 'admin-dashboard',
                element: <AdminDashboard />,
            },
            {
                path: 'team-information',
                element: <TeamInfo />,
            },
            {
                path: 'team-health',
                element: <TeamHealthDashboard />,
            },
            {
                path: 'settings',
                element: <SettingsPage />,
            },
            {
                path: 'athlete/:teamId/:athleteId',
                element: <AthleteDetail />,
            },
            {
                path: 'connect-whoop',
                element: <ConnectWhoop />,
            },
            {
                path: 'connect-whoop-callback',
                element: <WhoopOAuthCallback />,
            },
            {
                path: 'connect-whoop-simple',
                element: <WhoopSimple />,
            },
            {
                path: 'connect-whoop-simple-callback',
                element: <WhoopSimpleCallback />,
            },
            {
                path: 'connect-terra',
                element: <ConnectTerra />,
            },
            {
                path: 'connect-catapult-vector',
                element: <ConnectTerraCoach />,
            },
            {
                path: 'connect-wearable',
                element: <ConnectWearable />,
            },
            {
                path: 'sessions/athlete/:sessionId',
                element: <AthleteCheckIn />,
            },
            {
                path: 'daily-checkin/:date',
                element: <DailyCheckInForm />,
            },
        ],
    },
] as RouteObject[]);
